<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/call/balance-driver" text="" icon="chevron-back"></ion-back-button>
    </ion-buttons>
    <ion-title>Redeem Points</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

  <div class="container">
    <div class="text">
      <p>You have {{pontosEmAberto}} points ({{valorEmAberto | currency}})</p>
    </div>
    <footer>
      <ion-button expand="block" shape="round" [disabled]="!canRedeem()" (click)="redeemPoints()">Redeem
      </ion-button>
      <div class="text" style="margin-bottom: 5px;">
        <small>The minimum redemption amount is $5.</small>
      </div>
    </footer>
    <h4>Points Redemption history</h4>
    <section class="card-list" *ngIf="historicoPontos?.length">
      <!-- <h3 class="title">Redeem history</h3> -->
      <div *ngFor="let historicoPonto of historicoPontos">
        <h3 class="title">{{historicoPonto.dataSolicitacao | date: "MM/dd/yyyy" }}</h3>
        <ul class="list">
          <li>
            {{historicoPonto.pontosSolicitados}} points
            <strong>$ {{historicoPonto.valorSolicitado}}</strong>
          </li>
        </ul>
      </div>
    </section>
    <section class="card-list" *ngIf="!historicoPontos?.length">
      <!-- <h3 class="title">Redeem history</h3> -->
      <div>
        <!-- <h3 class="title">{{periodo.labelMes | date: "MM/dd/yyyy" }}</h3> -->
        <ul class="list">
          <li>
            No points were redeemed yet
          </li>
        </ul>
      </div>
    </section>
  </div>
</ion-content>